
<div class="row">

  <form *ngIf="formResetToggle" class="login" name="loginForm"
        [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>


        <div class="row">
          <div class="col-sm-4">
            <div class="form-check mb-3">
              <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />

              <label for="acceptTerms" class="form-check-label">US</label><br />
              <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
              <label for="acceptTerms" class="form-check-label">Canada  <code>*</code></label>
              <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback">US or Canada is required</div>
            </div>
          </div>

        </div>


        <div class="card card-secondary">
          <div class="card-header">
            <h3 class="card-title">ICD Info</h3>

            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">


            <div class="row">



              <div class="col-sm-4">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Distributor_Code">Distributor Number <code>*</code></label>
                  <input type="text" formControlName="Distributor_Code" class="form-control"
                         [ngClass]="{'is-valid': f.Distributor_Code.valid, 'is-invalid' : submitted && f.Distributor_Code.valid}" placeholder="EnterDistributor_Code"
                         appAiHint="Distributor Code" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Distributor_Code.errors" class="invalid-feedback">
                    <div *ngIf="f.Distributor_Code.errors.required">Distributor_Code  is required</div>
                  </div>

                </div>




              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-ICD_Owner_Name">ICD Owner's Name <code>*</code></label>
                  <input type="text" formControlName="ICD_Owner_Name" class="form-control"
                         [ngClass]="{'is-valid': f.ICD_Owner_Name.valid, 'is-invalid' : submitted && f.ICD_Owner_Name.valid}"
                         placeholder="Enter  Owner  Name"
                         appAiHint="ICD Owner Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.ICD_Owner_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.ICD_Owner_Name.errors.required">Owner  Name is required</div>
                  </div>

                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">

                  <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">ICD Corporation Name <code>*</code></label>
                  <input type="text" formControlName="Full_Legal_Company_Name" class="form-control"
                         [ngClass]="{'is-valid': f.Full_Legal_Company_Name.valid, 'is-invalid' : submitted && f.Full_Legal_Company_Name.valid}" placeholder="Enter Full Legal Company Name"
                         appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
                  <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                    <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
                  </div>

                </div>
              </div>


              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner<code>*</code></label>
                  <div class="col-md-12">
                    <ng-select [searchable]="true" formControlName="Promoting_Owner" (change)="onCheckboxPo($event)">
                      <ng-option *ngFor="let o of PO_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>

                    <div *ngIf="submitted && f.Promoting_Owner.errors" class="invalid-feedback">
                      <div *ngIf="f.Promoting_Owner.errors.required">Promoting Owner is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Promoting_Owner">Promoting Owner's Company<code>*</code></label>
                  <div class="col-md-12">
                    <input type="text" formControlName="Promoting_Owner_Company" class="form-control"
                           [ngClass]="{'is-valid': f.Promoting_Owner_Company.valid, 'is-invalid' : submitted && f.Promoting_Owner_Company.valid}" placeholder="Enter Promoting Owner Company"
                           appAiHint="Promoting Owner Company" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Promoting_Owner_Company.errors" class="invalid-feedback">
                      <div *ngIf="f.Promoting_Owner_Company.errors.required">Promoting  Company is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant</label>
                  <div class="col-md-12">

                    <ng-select [searchable]="true" formControlName="Regional_Consultant"
                               (change)="onCheckboxRC($event)">
                      <ng-option *ngFor="let o of RC_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>
                    <div *ngIf="submitted && f.Regional_Consultant.errors" class="invalid-feedback">
                      <div *ngIf="f.Regional_Consultant.errors.required">Regional Consultant is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Regional_Consultant">Regional Consultant's Company</label>
                  <div class="col-md-12">
                    <input type="text" formControlName="Regional_Consultant_Company" class="form-control"
                           placeholder="Enter Regional Consultant Company"
                           appAiHint="Regional Consultant Company" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Regional_Consultant_Company.errors" class="invalid-feedback">
                      <div *ngIf="f.Regional_Consultant_Company.errors.required">Regional Consultant Company is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-National_Consultant">National Consultant<code>*</code></label>
                  <div class="col-md-12">


                    <ng-select [searchable]="true" formControlName="National_Consultant" [ngClass]="{ 'is-invalid': submitted && f.National_Consultant.errors }"
                               (change)="onCheckboxNC($event)">
                      <ng-option *ngFor="let o of NC_namesData"
                                 [value]="o.ownerName">
                        {{ o.ownerNameCompany }}
                      </ng-option>
                    </ng-select>

                    <div *ngIf="submitted && f.National_Consultant.errors" class="invalid-feedback">
                      <div *ngIf="f.National_Consultant.errors.required">National Consultant is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-National_Consultant">National Consultant's Company<code>*</code></label>
                  <div class="col-md-12">
                    <input type="text" formControlName="National_Consultant_Company" class="form-control"
                           [ngClass]="{'is-valid': f.National_Consultant_Company.valid, 'is-invalid' : submitted && f.National_Consultant_Company.valid}" placeholder="Enter National Consultant Company"
                           appAiHint="National Consultant Company" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.National_Consultant_Company.errors" class="invalid-feedback">
                      <div *ngIf="f.National_Consultant_Company.errors.required">National Consultant Company is required</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Name">Hub Name<code>*</code></label>
                  <div class="col-md-12">
                    <input type="text" formControlName="HUB_Manager_Contact_Name" id="login-HUB_Manager_Contact_Name" name="HUB_Manager_Contact_Name" placeholder="Enter Hub Name" autocomplete="HUB_Manager_Contact_Name"
                           class="form-control"
                           appAiHint="HUB Manager Contact Name" [aiHintForm]="icdForm" />

                  </div>
                </div>
              </div>




              <div class="col-sm-4">

                <div class="form-group">
                  <label class="col-form-label  col-md-12" for="login-Hub_New">New Hub Name<code>*</code></label>
                  <div class="col-md-12">


                    <ng-select [searchable]="true" formControlName="Hub_New" [ngClass]="{ 'is-invalid': submitted && f.Hub_New.errors }"
                               >
                      <ng-option *ngFor="let o of Hubs_namesData"
                                 [value]="o.fullName">
                        {{ o.fullName }}
                      </ng-option>
                    </ng-select>

                    <div *ngIf="submitted && f.Hub_New.errors" class="invalid-feedback">
                      <div *ngIf="f.Hub_New.errors.required">New Hub Name is required</div>
                    </div>
                  </div>
                </div>
              </div>





            </div>

            <!--<div class="form-group pull-right" *ngIf="btnDisplay">
              <button type="button" class="btn btn-primary" (click)="saveSection1()">Save Info</button>
            </div>-->

          </div>

        </div>




      <!-- AI Pre-Submit Review Modal -->
      <app-pre-submit-review
        [visible]="showPreSubmitReview"
        [issues]="preSubmitIssues"
        [loading]="preSubmitLoading"
        (dismiss)="onPreSubmitDismiss()"
        (submitAnyway)="onPreSubmitDoSubmit()"
        (recheck)="onPreSubmitRecheck()"
        (autoFix)="onPreSubmitAutoFix($event)"
        (navigateToField)="onPreSubmitNavigate($event)">
      </app-pre-submit-review>
        <div class="mb-3" *ngIf="btnDisplay">


          <button type="submit" class="btn btn-success float-right">
            {{isLoading ? 'Submit' : 'Submit'}}

          </button>


        </div>
  </form>
</div>


